(function () {
  'use strict';

  /* @ngdoc object
   * @name dutySheet
   * @description
   *
   */
  angular
    .module('dutySheet', [
      'ui.router'
    ]);
}());
